<template>
  <div class="page-bar">
    <ul>
      <li v-if="curPage>1"><a v-on:click="curPage=1" class="banclick">首页</a></li>
      <li v-if="curPage==1"><a class="banclick">首页</a></li>
      <li v-if="curPage>1"><a v-on:click="curPage--" class="banclick">上一页</a></li>
      <li v-if="curPage==1"><a class="banclick">上一页</a></li>
      <li v-for="index in indexs" :key="index" v-bind:class="{'active': curPage == index}">
        <a v-on:click="btnClick(index)">{{ index }}</a>
      </li>
      <li v-if="curPage<pageNum"><a v-on:click="curPage++" class="banclick">下一页</a></li>
      <li v-if="curPage==pageNum"><a class="banclick">下一页</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PageBar',
  props: {
    pageNum: {
      type: Number,
      default: 1
    },
    curPage: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
    }
  },
  methods: {
    btnClick: function (data) {
      if (data !== this.curPage) {
        this.curPage = data
      }
    }
  },
  watch: {
    curPage (val) {
      this.$emit('changeCurPage', val)
    }
  },
  computed: {
    indexs: function () {
      var left = 1
      var right = this.pageNum
      var ar = []
      if (this.pageNum >= 6) {
        if (this.curPage > 3 && this.curPage < this.pageNum - 3) {
          left = this.curPage - 2
          right = this.curPage + 3
        } else {
          if (this.curPage <= 3) {
            left = 1
            right = 6
          } else {
            right = this.pageNum
            left = this.pageNum - 5
          }
        }
      }
      while (left <= right) {
        ar.push(left)
        left++
      }
      return ar
    }
  }
}
</script>

<style scoped>
.page-bar{
  /* width: 960px; */
  height: 57px;
  margin-top: 60px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #634C37;
}
ul,li{
  margin: 0px;
  padding: 0px;
  display: flex;
}
li{
  list-style: none;
}
.page-bar a{
  width: 26px;
  height: 26px;
  background: rgba(158,92,29,0);
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #D2CDC8;
  float: left;
  margin-left: 7px;
}
.page-bar a:hover{
  background-color: #d0c9c3 ;
}
.page-bar .active a{
  color:white;
  cursor: default;
  background: #9E5C1D;
  border-radius: 0px 0px 0px 0px;
}
.page-bar a.banclick{
  width: 60px;
  height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageBar.vue